module.exports = __webpack_public_path__ + "static/Ing_Martin_Mroč_Resume-1589fdf3f1e1a2d015ba55ab8ef42936.pdf";